/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, CardContent, Typography, Skeleton } from "@mui/material";
import MeQuery from "src/graphql/query/auth/me";
import { useQuery } from "@apollo/client";
import ChangePassword from "./ChangePassword";
import Details from "./Details";
import VoicePreferences from "./VoicePreferences";
import useStyles from "./Styles";

const ProfileSettings = () => {
  const { classes } = useStyles();
  const { data: meQueryResult, loading: MeQueryLoading } = useQuery(MeQuery, {
    fetchPolicy: "network-only",
  });

  return (
    <Box className={classes.innerContainer}>
      {/* Header */}
      <Box className={classes.profileBox}>
        <Typography className={classes.headerTextSection}>
          Profile Settings
        </Typography>
      </Box>

      <CardContent className={classes.cardContent}>
        {!MeQueryLoading ? (
          <Box className={classes.box}>
            {/* Profile Details Section */}
            <Box className={classes.sectionCard}>
              <Typography className={classes.sectionTitle}>
                Personal Information
              </Typography>
              <Details meQueryResult={meQueryResult ?? {}} />
            </Box>

            {/* Change Password Section */}
            <Box className={classes.sectionCard}>
              <Typography className={classes.sectionTitle}>
                Security &amp; Password
              </Typography>
              <ChangePassword meQueryResult={meQueryResult ?? {}} />
            </Box>

            {/* Voice Messages (Text-to-Speech) */}
            <Box className={classes.sectionCard}>
              <Typography className={classes.sectionTitle}>
                Voice Messages (Text-to-Speech)
              </Typography>
              <VoicePreferences />
            </Box>
          </Box>
        ) : (
          // Rich skeleton that mirrors the real card layout
          <Box className={classes.box}>
            {/* Personal info card skeleton */}
            <Box className={classes.sectionCard}>
              <Skeleton variant="text" width={180} height={18} sx={{ mb: 2 }} />
              {/* Avatar row */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: "14px 18px",
                  borderRadius: "12px",
                  backgroundColor: "rgba(0,0,0,0.03)",
                  mb: 3,
                }}
              >
                <Skeleton variant="circular" width={72} height={72} />
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Skeleton variant="text" width={100} height={16} />
                  <Skeleton variant="text" width={140} height={13} />
                </Box>
              </Box>
              {/* Fields row */}
              <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
                {[1, 2, 3].map((i) => (
                  <Box key={i} sx={{ flex: "1 1 200px", minWidth: 200 }}>
                    <Skeleton
                      variant="text"
                      width={80}
                      height={14}
                      sx={{ mb: 1 }}
                    />
                    <Skeleton variant="rounded" width="100%" height={42} />
                  </Box>
                ))}
              </Box>
              <Skeleton
                variant="rounded"
                width={130}
                height={40}
                sx={{ mt: 3, borderRadius: "10px" }}
              />
            </Box>
            {/* Password card skeleton */}
            <Box className={classes.sectionCard}>
              <Skeleton variant="text" width={160} height={18} sx={{ mb: 2 }} />
              <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
                {[1, 2, 3].map((i) => (
                  <Box key={i} sx={{ flex: "1 1 200px", minWidth: 200 }}>
                    <Skeleton
                      variant="text"
                      width={90}
                      height={14}
                      sx={{ mb: 1 }}
                    />
                    <Skeleton variant="rounded" width="100%" height={42} />
                  </Box>
                ))}
              </Box>
              <Skeleton
                variant="rounded"
                width={145}
                height={40}
                sx={{ mt: 3, borderRadius: "10px" }}
              />
            </Box>
          </Box>
        )}
      </CardContent>
    </Box>
  );
};

export default ProfileSettings;
